import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';
import {LineStyle} from 'ui-library/reactflow/edges/edgeOptions';

import {getEdgeStatus} from './edgeUtils';

export default function TaskSchemaDataFlowEdge(props: EdgeProps): JSX.Element {
  return (
    <BaseEdgeRenderer
      {...props}
      data={{
        ...(props.data ?? {}),
        lineStyle: LineStyle.DASHED,
        status: getEdgeStatus(props),
      }}
    />
  );
}
